<template>
  <div class="menuLabel fvlw">
    <span
      class="labelItem"
      :class="{ active: hasActive(item) }"
      @click.stop="clickLabel(item)"
      v-for="(item, index) in labelData"
      :key="index + '_' + item.identifier"
      >{{ item?.name }}<van-icon v-if="item?.identifier === 'showMore'" name="arrow-down"
    /></span>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import _ from 'lodash'

export default {
  name: 'menuLabel',

  props: {
    datas: {
      default: () => [],
      type: Array
    },
    pid: {
      default: () => '',
      type: String
    },
    gid: {
      default: () => '',
      type: String
    }
  },
  setup(props, { emit }) {
    let store = useStore()
    let { datas, pid, gid } = toRefs(props)
    const state = reactive({
      datas,
      pid,
      gid,
      size: 4,
      isShowMore: true
    })
    const allLabelData = computed(() => state.datas.map(item => ({ ...item, pid: state.pid, gid: state.gid })))
    const moreData = computed(() => {
      let showMore = { name: '查看更多', identifier: 'showMore' }
      let showMoreArr = allLabelData.value.length > state.size ? [showMore] : []
      return [...allLabelData.value.slice(0, state.size), ...showMoreArr]
    })
    const packUpData = computed(() => {
      let packUp = { name: '收起', identifier: 'packUp' }
      let packUpArr = allLabelData.value.length > state.size ? [packUp] : []
      return [...allLabelData.value.slice(0), ...packUpArr]
    })
    const labelData = computed(() => {
      let allLabelItem = { name: '全部', en: 'all', identifier: state.pid, pid: state.pid, gid: state.gid, child: allLabelData.value }
      return state.isShowMore ? [allLabelItem, ...moreData.value] : [allLabelItem, ...packUpData.value]
    })
    const selectShopMenuItem = computed(() => store.state.selectShopMenuItem)
    const clickLabel = data => {
      // console.log('clickLabel', data)
      if (['showMore', 'packUp'].includes(data.identifier)) {
        state.isShowMore = !(data.identifier === 'showMore')
        return
      }
      let setData = []
      if (data.identifier === data.pid) {
        setData = selectShopMenuItem.value.filter(item => item.pid !== data.pid).concat([{ ...data }])
      } else {
        setData = selectShopMenuItem.value.filter(item => item.identifier !== data.pid).concat([{ ...data }])
      }
      store.commit('SETSELECTSHOPMENUITEM', [...setData])
    }
    const hasActive = item => {
      return selectShopMenuItem.value.find(label => label.identifier === item.identifier)
    }
    onMounted(async () => {})
    return {
      ...toRefs(state),
      labelData,
      selectShopMenuItem,
      hasActive,
      clickLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.menuLabel {
  background: #fff;
  .labelItem {
    margin: 4px 5px;
    padding: 4px 10px;
    background: #eee;
    border: 1px solid transparent;
    border-radius: 14px;
    box-sizing: border-box;
  }
  .active {
    border: 1px solid #3088c5;
    color: #3088c5;
    background: #fff;
  }
}
</style>
